// Configuration for the phishing report add-in
export const config = {
  // Backend API URL
  BACKEND_URL: 'https://addin-qa.awareness10.com', // For development - change to production URL when deploying
  
  // MSAL Configuration for Public Client (Frontend)
  MSAL: {
    auth: {
      clientId: "99420d79-b771-4292-ab97-db0740804d86",
      authority: "https://login.microsoftonline.com/c57a6312-a863-4e2c-8915-e95e9a91f1a8",
      redirectUri: "https://addin-config-qa.awareness10.com/commands.html"
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false
    },
    scopes: ["User.Read", "Mail.ReadWrite"],
    system: {
      allowRedirectInIframe: true,
      allowNativeBroker: false,
      popupWindowAttributes: {
        width: 600,
        height: 700,
        left: 100,
        top: 100
      },
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          console.log(message);
        },
        logLevel: "Info",
      }
    }
  },

  // MSAL Configuration for Commands (Different from taskpane)
  MSAL_COMMANDS: {
    auth: {
      clientId: "50eda291-dc48-47f8-8b53-a3e68df0df2b",
      authority: "https://login.microsoftonline.com/common"
    }
  },
  
  // Default settings
  DEFAULTS: {
    forwardTo: "security@company.com",
    targetFolder: "quarantine",
    maxActionLogs: 10
  },

  // UI Configuration
  UI: {
    // Placeholder texts
    placeholders: {
      forwardEmail: "security@company.com",
      endpointUrl: "https://api.example.com/webhook",
      emailSubject: "subject here...",
      emailBody: "Additional body here..."
    },
    
    // Error messages
    messages: {
      accessDenied: "You don't have permission to use this add-in. Please contact SolidRange at GRC and Human Risk Management Solutions to get started with A10 platform.",
      noAdminConfigured: "Your organization needs to be configured by an administrator first. Please contact your IT administrator.",
      userNotFound: "You don't have permission to use this add-in. Please contact SolidRange at GRC and Human Risk Management Solutions to get started with A10 platform.",
      initializationFailed: "Failed to initialize app",
      settingsSaveSuccess: "User settings saved successfully",
      forwardEmailRequired: "Forward email address is required",
      forwardEmailRequiredMessage: "Forward email address is required to save settings"
    }
  },
  
  // API Endpoints
  ENDPOINTS: {
    CHECK_PERMISSION: "/auth/checkPermission",
    FORWARD_EMAIL: "/api/forwardEmail",
    MOVE_EMAIL: "/api/moveEmail",
    DELETE_EMAIL: "/api/deleteEmail",
    REPORT_PHISHING: "/api/reportPhishing",
    ACTION_LOGS: "/api/actionLogs"
  }
};

export default config;
